import { transition } from '@helpers/animate';
import brand, { ThemeOption } from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import styled, { css } from 'styled-components';
const Text = styled.div `
  ${fonts.agBook.bold}
  font-size: var(--fontSize);
  color: var(--buttonFgColor);

  [data-element-size='small'] &,
  [data-element-size='medium'] & {
    --fontSize: 16px;
  }

  [data-element-size='large'] & {
    --fontSize: ${fluid(16, 20)};
  }
`;
const iconLeftStyles = css `
  padding-right: 10px;
`;
const iconRightStyles = css `
  padding-left: 10px;
`;
const Icon = styled.div `
  display: inline-block;
  vertical-align: middle;
  padding-top: 2px;
  transition: transform 0.3s;
  line-height: 0;

  ${({ position }) => {
    switch (position) {
        case 'left':
            return iconLeftStyles;
        case 'right':
            return iconRightStyles;
        default:
            break;
    }
}}

  svg {
    max-height: 26px;
    max-width: 26px;
    width: 100%;
  }
`;
const borderButtonStyles = css `
  --themeColor: ${brand.black};
  --buttonFgColor: ${brand.black};
  --buttonBgColor: transparent;

  &[data-element-theme=${ThemeOption.Orange}] {
    --themeColor: ${brand.orange};
    --buttonFgColor: ${brand.orange};
  }

  &[data-element-theme=${ThemeOption.Blue}] {
    --themeColor: ${brand.blue};
    --buttonFgColor: ${brand.blue};
  }

  &[data-element-theme=${ThemeOption.Purple}] {
    --themeColor: ${brand.purple};
    --buttonFgColor: ${brand.purple};
  }

  &[data-element-theme=${ThemeOption.Red}] {
    --themeColor: ${brand.red};
    --buttonFgColor: ${brand.red};
  }

  &[data-element-theme=${ThemeOption.Green}] {
    --themeColor: ${brand.green.default};
    --buttonFgColor: ${brand.green.default};
  }

  &[data-element-theme=${ThemeOption.DarkGreen}] {
    --themeColor: ${brand.green.dark};
    --buttonFgColor: ${brand.green.dark};
  }

  &[data-element-theme=${ThemeOption.Teal}] {
    --themeColor: ${brand.teal};
    --buttonFgColor: ${brand.teal};
  }

  border: 2px solid var(--buttonBorderColor);
`;
const solidButtonStyles = css `
  --themeColor: ${brand.white};
  --buttonFgColor: ${brand.teal};

  &[data-element-theme=${ThemeOption.Orange}] {
    --themeColor: ${brand.orange};
    --buttonFgColor: ${brand.white};
  }

  &[data-element-theme=${ThemeOption.Blue}] {
    --themeColor: ${brand.blue};
    --buttonFgColor: ${brand.white};
  }

  &[data-element-theme=${ThemeOption.Purple}] {
    --themeColor: ${brand.purple};
    --buttonFgColor: ${brand.white};
  }

  &[data-element-theme=${ThemeOption.Red}] {
    --themeColor: ${brand.red};
    --buttonFgColor: ${brand.white};
  }

  &[data-element-theme=${ThemeOption.Green}] {
    --themeColor: ${brand.green.default};
    --buttonFgColor: ${brand.white};
  }

  &[data-element-theme=${ThemeOption.DarkGreen}] {
    --themeColor: ${brand.green.dark};
    --buttonFgColor: ${brand.white};
  }

  &[data-element-theme=${ThemeOption.Teal}] {
    --themeColor: ${brand.teal};
    --buttonFgColor: ${brand.white};
  }

  &[data-solid-invert='true'] {
    --buttonBgColor: ${brand.white};
    --buttonFgColor: var(--themeColor);
  }
`;
const textButtonStyles = css `
  --buttonHeight: 26px;
  --buttonFgColor: currentColor;
  --themeColor: transparent;

  &&& {
    --buttonEdgePadding: 0px;
  }

  svg path {
    ${transition('stroke-width')}
  }

  &:hover,
  &:focus {
    &&& {
      opacity: 1;
    }

    svg path {
      stroke-width: 5;
    }
  }
`;
const baseButtonStyles = css `
  --buttonFgColor: ${brand.black};
  --buttonBgColor: var(--themeColor);
  --buttonBorderColor: var(--themeColor);

  &[data-element-size='small'] {
    --buttonHeight: ${fluid(16, 38)};
    --buttonEdgePadding: 14px;
  }

  &[data-element-size='medium'] {
    --buttonHeight: ${fluid(16, 42)};
    --buttonEdgePadding: 22px;
  }

  &[data-element-size='large'] {
    --buttonHeight: ${fluid(16, 48)};
    --buttonEdgePadding: 22px;
  }

  display: inline-flex;
  align-items: center;
  height: var(--buttonHeight);
  padding: 6px var(--buttonEdgePadding);
  background-color: var(--buttonBgColor);
  ${transition('opacity')}

  svg {
    color: var(--buttonFgColor);
  }

  &:hover,
  &:focus {
    opacity: 0.5;
  }
`;
const Button = styled.button `
  ${ButtonReset}
  ${baseButtonStyles};

  ${({ styleType }) => {
    switch (styleType) {
        case 'border':
            return borderButtonStyles;
        case 'solid':
            return solidButtonStyles;
        default:
        case 'text':
            return textButtonStyles;
    }
}}

  &:is(a) {
    color: inherit;
    text-decoration: none;
  }
`;
export const ButtonStyles = {
    Button,
    Icon,
    Text,
    baseButtonStyles,
    borderButtonStyles,
    solidButtonStyles,
    textButtonStyles,
};
